import { t } from 'i18next';

enum ReportStatusFilter {
    Draft = 1,
    ToBeTranscribed = 2,
    Transcribed = 3,
    Preliminary = 4,
    Validated = 5,
}

export const getReportStatusFilterString = (status: ReportStatusFilter): string => {
    switch (status) {
        case ReportStatusFilter.Draft:
            return t('Draft');
        case ReportStatusFilter.ToBeTranscribed:
            return t('ToBeTranscribed');
        case ReportStatusFilter.Transcribed:
            return t('Transcribed');
        case ReportStatusFilter.Preliminary:
            return t('Preliminary');
        case ReportStatusFilter.Validated:
            return t('Validated');
    }
};

export default ReportStatusFilter;
